module.exports = __webpack_public_path__ + "static/media/img2.e76a3e20.jpg";